<div class="sheet-wrapper">
  <div class="sheet-title">{{ title }}</div>
  <div class="sheet-content">{{ contentText }}</div>
  <button class="close-button" mat-stroked-button
          [tabIndex]="-1"
          (click)="closeBottomSheet()">{{ closeLabel }}</button>
</div>
